import { render } from "./ChannelIcon.vue?vue&type=template&id=2bc9397f&scoped=true&bindings={\"channelId\":\"props\",\"size\":\"props\",\"config\":\"setup\",\"channel\":\"setup\",\"iconSize\":\"setup\"}"
import script from "./ChannelIcon.vue?vue&type=script&lang=js"
export * from "./ChannelIcon.vue?vue&type=script&lang=js"

import "./ChannelIcon.vue?vue&type=style&index=0&id=2bc9397f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2bc9397f"

export default script